RivalIQ.apps.Discovery.module('data', function (data, App, Backbone, Marionette, $, _) {

    'use strict';

    data.FollowActionsHelper = {

        // Attempts to make the presence with userId=followerUserId follow the user with id toBeFollowedUserId.
        // Note that all ids are nativeIds, not RivalIQ ids.
        // Returns a promise which will resolve to the new status after the api is executed.
        followUser: function (channel, followerUserId, toBeFollowedUserId) {
            const url = `/api/accounts/${RivalIQ.state.account.get('id')}/discovery/${channel}/follow`;

            return $.post(url, {
                followerUserId: followerUserId,
                toBeFollowedUserId: toBeFollowedUserId
            });
        },

        // Attempts to make the presence with toBeFollowedUserId=followerUserId unfollow the user with id toBeFollowedUserId.
        // Note that all ids are nativeIds, not RivalIQ ids.
        // Returns a promise which will resolve to the new status after the api is executed.
        unfollowUser: function (channel, followerUserId, toBeUnfollowedUserId) {
            const url = `/api/accounts/${RivalIQ.state.account.get('id')}/discovery/${channel}/unfollow`;

            return $.post(url, {
                followerUserId: followerUserId,
                toBeUnfollowedUserId: toBeUnfollowedUserId
            });
        }
    };

});
